import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import s from './BookingIdSkeletonCard.css'

function BookingIdSkeletonCard() {
    return (
        <div className={s.bookingIdSkeletonBox}>
            <div className={s.bookingIdSkeletonInfoContainer}>
                <Skeleton className={s.bookingIdSkeletonInfoTile} />
                <Skeleton className={s.bookingIdSkeletonInfoDesc} />
            </div>
        </div>
    )
}

export default withStyles(s)(BookingIdSkeletonCard);
